/**
 * Axis / legend labels for pre–post quiz bar charts by bot + path key
 * (e.g. lwazi_personal, lesedi_path1). Consumed by ReportsBaseService.
 */
export type PrePostQuizQuestionsConfig = { [key: string]: string[] };

/** Lesedi path1 & path2 share the same question labels (isiZulu path mirrors digital literacy set). */
export const LESEDI_PREPOST_QUIZ_LABELS: string[] = [
  'Q1: Investments',
  'Q2: Diversification',
  'Q3: Budgeting',
  'Q4: ETFs',
  'Q5: Risks',
  'Q6: Emergencies',
  'Q7: Debt',
  'Q8: Loans',
  'Q9: Evaluation',
];

/** Mpilo path1 (Branch Manager) & path2 (Call Center Agent) share the same question labels until pathway-specific copy is supplied. */
export const MPILO_PREPOST_QUIZ_LABELS: string[] = [
  'Q1: PFA',
  'Q2: Emotions',
  'Q3: Stress',
  'Q4: Colleagues',
  'Q5: Distress',
  'Q6: Tools',
  'Q7: Support',
  'Q8: Burnout',
  'Q9: Safety',
  'Q10: Referral',
];

export const PRE_POST_QUIZ_QUESTIONS_CONFIG: PrePostQuizQuestionsConfig = {
  lwazi_personal: [
    'Q1: Emergencies',
    'Q2: Credit',
    'Q3: Insurance',
    'Q4: Advisers',
    'Q5: Scores',
    'Q6: Interest',
    'Q7: Retirement',
    'Q8: Savings',
    'Q9: Scams',
    'Q10: Investments',
  ],
  lwazi_business: [
    'Q1: Management',
    'Q2: Bookkeeping',
    'Q3: Cashflow',
    'Q4: Statements',
    'Q5: Budgets',
    'Q6: Tax',
    'Q7: Financing',
    'Q8: Receivables',
    'Q9: Profitability',
    'Q10: Readiness',
  ],
  lesedi_path1: [...LESEDI_PREPOST_QUIZ_LABELS],
  lesedi_path2: [...LESEDI_PREPOST_QUIZ_LABELS],
  kitso_path1: [],
  kitsoecd_path1: [
    'Q1: Footprint',
    'Q2: Registration',
    'Q3: Security',
    'Q4: Tools',
    'Q5: Compliance',
    'Q6: ChatGPT',
    'Q7: Platforms',
    'Q8: Communication',
    'Q9: WhatsApp',
    'Q10: Troubleshooting',
  ],
  kitsozazi_path1: [
    'Q1: Zazi',
    'Q2: Reading',
    'Q3: Sessions',
    'Q4: EGRA',
    'Q5: Catch-Up',
    'Q6: Sounds',
    'Q7: Retention',
    'Q8: Games',
    'Q9: Evidence',
    'Q10: Challenges',
  ],
  kitsoai_path1: [
    'Q1: Definition',
    'Q2: Automation',
    'Q3: Daily',
    'Q4: Growth',
    'Q5: Learning',
    'Q6: Distinction',
    'Q7: Impact',
    'Q8: Creation',
    'Q9: Accuracy',
    'Q10: Differentiation',
  ],
  /** Pathway 2 — same question set as path1 until pathway-specific copy is supplied. */
  kitsoai_path2: [
    'Q1: Definition',
    'Q2: Automation',
    'Q3: Daily',
    'Q4: Growth',
    'Q5: Learning',
    'Q6: Distinction',
    'Q7: Impact',
    'Q8: Creation',
    'Q9: Accuracy',
    'Q10: Differentiation',
  ],
  mpilo_path1: [...MPILO_PREPOST_QUIZ_LABELS],
  mpilo_path2: [...MPILO_PREPOST_QUIZ_LABELS],
};
